export default __webpack_public_path__ + "static/media/qc.d7dc3d30.png";